interface TrackMapType {
  [key: string]: Array<string>;
}

const trackMap: TrackMapType = {
  home: [
    'home_summary_open_calendar_sw',
    'home_summary_download_sw',
    'home_summary_total_sw',
    'home_summary_account_sw',
    'home_summary_cash_sw',
    'home_summary_history_sw',
  ],
  driver: [
    'driver_add_driver_sw',
    'driver_find_drivers_sw',
    'driver_change_btn_sw',
    'driver_driver_list_sw',
  ],
  vehicle: [
    'vehicle_add_car_sw',
    'vehicle_driver_detail_sw',
  ],
  mine: [
    'mine_username_sw',
    'mine_call_phone_sw',
  ],
  driverDetail: [
    'driver_delete_driver_btn_sw',
  ],
  vehicleDetail: [
    'vehicle_detail_delete_car_btn_sw',
  ],
};

export default trackMap;
